import IconChartDiagramSolid from '@/assets/icons/font_awesome/chart-diagram-solid.svg?react';
import IconListSolid from '@/assets/icons/font_awesome/list-solid.svg?react';
import IconTableCellsLargeSolid from '@/assets/icons/font_awesome/table-cells-large-solid.svg?react';
import IconTableCellsSolid from '@/assets/icons/font_awesome/table-cells-solid.svg?react';
import { EPagesMobileTabs } from '@/enums/EPagesMobileTabs';
import { use_slice_generation } from '@/hooks/store/use_slices';
import { LayoutPageMobileWithTabs } from '@/layouts/LayoutPageMobileWithTabs';
import { TabsContent } from '@radix-ui/react-tabs';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { useState } from 'react';
import { GRID2D__master } from '../_base/grid2d/views/GRID2D__master';
import { U_SIDEBAR__user_tasks_list } from './user_tasks_list/U_SIDEBAR__user_tasks_list';

export function PageUserTasksViewsMobile() {
  const { generation_current, user_task_current } = use_slice_generation(['generation_current', 'user_task_current']);

  const [activeTab, setActiveTab] = useState(EPagesMobileTabs.USER_TASKS_LIST);

  function render_right_sidebar() {
    let out = <></>;

    if (generation_current.is_stub()) return out;

    out = <></>;

    return out;
  }

  return (
    <>
      <LayoutPageMobileWithTabs
        tabs={[
          EPagesMobileTabs.USER_TASKS_LIST,
          EPagesMobileTabs.USER_TASKS_HISTORY,
          EPagesMobileTabs.USER_TASKS_GRID2D,
          EPagesMobileTabs.USER_TASKS_GENERATION_GRID2D,
        ]}
        icons={[<IconListSolid />, <IconChartDiagramSolid />, <IconTableCellsSolid />, <IconTableCellsLargeSolid />]}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      >
        <TabsContent className={`mt-0 !max-h-[calc(100vh-7.5rem)] h-[calc(100vh-7.5rem)]`} value={EPagesMobileTabs.USER_TASKS_LIST}>
          <U_SIDEBAR__user_tasks_list />
        </TabsContent>
        <TabsContent
          className={`mt-0 !max-h-[calc(100vh-7.5rem)] h-[calc(100vh-7.5rem)] min-h-0 flex flex-col`}
          value={EPagesMobileTabs.USER_TASKS_HISTORY}
        ></TabsContent>
        <TabsContent className={`mt-0 !max-h-[calc(100vh-7.5rem)] h-[calc(100vh-7.5rem)]`} value={EPagesMobileTabs.USER_TASKS_GRID2D}>
          <div className="w-full h-full text-center relative flex flex-col">
            <GRID2D__master entity_type={ENUM__workspace_entity.ENTITY_USER_TASK} entity_id={user_task_current._id} />
          </div>
        </TabsContent>
        <TabsContent className={`mt-0 !max-h-[calc(100vh-7.5rem)] h-[calc(100vh-7.5rem)]`} value={EPagesMobileTabs.USER_TASKS_GENERATION_GRID2D}>
          <div className="w-full h-full text-center relative flex flex-col">{render_right_sidebar()}</div>
        </TabsContent>
      </LayoutPageMobileWithTabs>
    </>
  );
}
